/**
 * Welcome article — the first thing a new user lands on in the KB.
 * Kept short on purpose; per-feature deep dives live in their own
 * articles (qr-codes, short-urls, landing-pages, ...).
 *
 * Phase 3a delivers the renderer + this placeholder. Phase 3b drafts
 * the rest of the content from code.
 */

export const welcome = {
  slug: 'welcome',
  title: 'Welcome to LinkHub',
  category: 'Getting started',
  order: 0,
  // requiredRole left undefined → article is visible to everyone signed in.
  body: `
# Welcome to LinkHub

LinkHub is the Pam Golding link, QR code, and landing page platform. This
help centre walks you through every feature.

## What you can do here

- **QR codes** — generate trackable QR codes that link to listings, pages,
  or anywhere on the web.
- **Short URLs** — turn long URLs into short, brandable links you can drop
  into emails, SMS, or social posts.
- **Landing pages** — build standalone pages without a developer.
- **Bio links** — a single "link in bio" page for socials.
- **Analytics** — see who scanned what, where, and when.

## Getting around

The sidebar on the left groups every area of the app. Each list page —
QR codes, Short URLs, Landing Pages, Bio Links — has a "Create" button
that walks you through a short wizard.

## Where to next

- Browse the topic-specific articles in the sidebar to learn about
  individual features.
- Look for the small **?** icons next to form fields — they explain what
  to type, with examples.
- Stuck? Use the legacy admin login button on the sign-in page if you
  can't get into Alchemy.

> **Note** — this knowledge base is being built out. If you see a topic
> that's missing, let your administrator know.
`.trim(),
};

export default welcome;
